import { useAuth } from '../../contexts/AuthContext';
import { ROLE_LABELS, ROLE_LEVEL } from '../../utils/constants';
import { Eye } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator,
} from '../ui/dropdown-menu';

const IMPERSONATABLE_ROLES = ['super_admin', 'admin', 'org_admin', 'editor', 'trainer'];

export default function RoleImpersonationDropdown() {
  const { user, impersonatingRole, canImpersonate, startImpersonation, stopImpersonation } = useAuth();

  if (!canImpersonate()) return null;

  const userLevel = ROLE_LEVEL[user?.role] || 0;
  // Only show roles at or below the user's real level
  const availableRoles = IMPERSONATABLE_ROLES.filter(r => (ROLE_LEVEL[r] || 0) <= userLevel);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="impersonate-role-trigger"
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
            impersonatingRole
              ? 'bg-amber-400 text-amber-950 hover:bg-amber-500'
              : 'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
        >
          <Eye className="w-3.5 h-3.5" />
          {impersonatingRole ? `Testing: ${ROLE_LABELS[impersonatingRole]}` : 'Test as Role'}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48" data-testid="impersonate-role-menu">
        {availableRoles.map((role) => (
          <DropdownMenuItem
            key={role}
            data-testid={`impersonate-${role}`}
            onClick={() => startImpersonation(role)}
            className={impersonatingRole === role ? 'bg-amber-100 dark:bg-amber-900/30' : ''}
          >
            {ROLE_LABELS[role]}
            {role === user?.role && <span className="ml-auto text-xs text-muted-foreground">(your role)</span>}
          </DropdownMenuItem>
        ))}
        {impersonatingRole && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={stopImpersonation}
              data-testid="exit-impersonation-dropdown"
              className="text-amber-700 dark:text-amber-400 font-medium"
            >
              Exit Impersonation
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
